import { Box, Typography, Button } from '@mui/material';
import BlockIcon from '@mui/icons-material/Block';
import { useAuth } from '../contexts/AuthContext';

export default function BlockedPage() {
  const { logout } = useAuth();

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        gap: 2,
        p: 3,
        textAlign: 'center',
      }}
    >
      <BlockIcon sx={{ fontSize: 64, color: 'error.main' }} />
      <Typography variant="h5">Your account has been blocked</Typography>
      <Typography variant="body1" color="text.secondary">
        Please contact an administrator if you believe this is a mistake.
      </Typography>
      <Button variant="outlined" onClick={logout} sx={{ mt: 2 }}>
        Sign out
      </Button>
    </Box>
  );
}
